import { useEffect, useState } from "react";
import { callHttpClientMethod } from "../../../services/callHttpClient";
import { allPlants } from "../../../services/apiList";
import { BASE_URL, HttpMethod } from "../../../services/api.constant";
import { Product } from "../../../gobalType";
import { normalizePlantApiResponse } from "../../../utils/normalizePlantApiResponse";

type State = { loading: boolean; plants: Product[] };

export function useAllPlantsSearchList(enabled: boolean): State {
  const [state, setState] = useState<State>({ loading: true, plants: [] });

  useEffect(() => {
    if (!enabled) {
      setState({ loading: false, plants: [] });
      return;
    }

    let cancelled = false;

    const load = async () => {
      setState({ loading: true, plants: [] });
      try {
        const res = await callHttpClientMethod(
          BASE_URL + allPlants(),
          HttpMethod.Get,
          { category_id: [], size_name: [] },
          {}
        );
        if (cancelled) return;
        setState({
          loading: false,
          plants: normalizePlantApiResponse(res),
        });
      } catch {
        if (!cancelled) setState({ loading: false, plants: [] });
      }
    };

    void load();
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return state;
}
